export var createTenantsPhoneApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/phone");
    var filesApi = {
        enable: function () {
            return http.post("".concat(url, "/enable"), {});
        },
        disable: function () {
            return http.post("".concat(url, "/disable"), {});
        },
    };
    return filesApi;
};
//# sourceMappingURL=index.js.map